const DEFAULT_VARIANT = {
  key: 'domainkings-default',
  title: 'Tell us about your company and ICP',
  intro:
    'We return registrar-verified domain options. When you pick the landing package, previews use the same section-based templates we deliver after checkout.',
  submitLabel: 'Generate Domain Options',
  fields: {
    company: { label: 'Company Name *', placeholder: 'e.g., Nebula AI', required: true, visible: true },
    industry: { label: 'Industry', placeholder: 'Select industry...', visible: true },
    location: { label: 'Location', placeholder: 'e.g., Austin, TX', visible: true },
    email: { label: 'Email (optional)', placeholder: 'your@email.com', required: false, visible: true },
    website: { label: 'Current Website', placeholder: 'e.g., acme.com (optional)', visible: true },
  },
};

const LEADIDEAL_LEGAL_VARIANT = {
  key: 'leadideal-legal',
  title: 'Tell us about your firm and target legal buyers',
  intro:
    'We match legal-focused domain and landing options to your offer. Share your ICP details, then generate options aligned to legal decision-maker outreach.',
  submitLabel: 'Generate Legal Domain Options',
  fields: {
    company: { label: 'Company / Firm Name *', placeholder: 'e.g., Smith & Cole LLP', required: true, visible: true },
    industry: { label: 'Vertical', placeholder: 'Select vertical...', visible: true },
    location: { label: 'Target Market', placeholder: 'e.g., US law firms in Texas', visible: true },
    email: { label: 'Work email (optional)', placeholder: 'you@firm.com', required: false, visible: true },
    website: { label: 'Current Website', placeholder: 'e.g., firm.com (optional)', visible: false },
  },
};

export const resolveFormVariant = (search = '', hostname = '') => {
  const params = new URLSearchParams(search);
  const ref = (params.get('ref') || '').toLowerCase();
  const industry = (params.get('industry') || '').toLowerCase();
  const host = (hostname || '').toLowerCase();

  if ((ref === 'leadideal' || host.includes('leadideal.com')) && industry === 'legal') {
    return LEADIDEAL_LEGAL_VARIANT;
  }

  return DEFAULT_VARIANT;
};
